<template>
  <div ref="miniCategories" class="grid-4n">
    <div v-for="(category, index) in categories" :key="index" class="grid-item">
      <nuxt-link
        v-if="category && category.offerProductName && category.offerProduct"
        :to="getLink(category)"
      >
        <filter-tile>
          <template #image>
            <app-image
              ratio="1by1"
              :src="getImageBySize(category.imageGroup, 'big').src"
              :webp-fallback="getImageBySize(category.imageGroup, 'big').webpFallback"
              :alt="category.offerProductName || 'schuette product'"
              lazy
            />
          </template>
          <template #name>
            <p class="tile-name">
              <template v-if="category.description">
                {{ category.description.name }}
              </template>
            </p>
          </template>
          <template #buttons>
            <b-button type="is-primary" class="cta-primary" expanded rounded icon-right="arrow-right-bold">
              {{ resolveButtonLabel(category) }}
            </b-button>
          </template>
        </filter-tile>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import FilterTile from '~/components/shared/FilterTile'

import equalHeight from '~/mixin/equalHeight'

export default {
  components: {
    FilterTile
  },
  mixins: [equalHeight],
  props: {
    categories: {
      type: Array,
      default () {
        return []
      }
    },
    home: {
      type: Boolean
    },
    buttonLabel: {
      type: [String, Function],
      default: null
    }
  },
  data () {
    return {
      titlesHeightStyleAdded: false
    }
  },
  // computed: {
  //   filteredCategories () {
  //     return this.categories
  //   }
  // },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  destroyed () {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    resolveButtonLabel (category) {
      const label = typeof this.buttonLabel === 'function' ? this.buttonLabel(category) : this.buttonLabel
      return label || this.$t('project.landingPage.browseAll')
    },
    resize () {
      if (window.innerWidth < 1024 && this.titlesHeightStyleAdded) {
        this.setEqualHeight(this.$refs.miniCategories, '.filter-name', false)
        this.titlesHeightStyleAdded = false
      } else if (window.innerWidth >= 1024 && !this.titlesHeightStyleAdded) {
        this.setEqualHeight(this.$refs.miniCategories, '.filter-name', true)
        this.titlesHeightStyleAdded = true
      }
    },
    getLink (category) {
      if (this.home) {
        // return this.getLinkProduct(category)
        return this.getLinkCategories(category.identifier)
      } else {
        return this.getLinkProduct(category)
      }
    },
    getLinkCategories (identifier) {
      switch (identifier) {
        case 'plisy':
          return this.localePath('categories-pleated-blinds')
        case 'roletki':
          return this.localePath('categories-roller-blinds')
        case 'zaslony':
          return this.localePath('categories-curtains')
        case 'relax':
          return this.localePath('categories-relax')
        default:
          return null
      }
    },
    getLinkProduct (category) {
      if (category && category.link && category.offerProduct) {
        return this.localePath({
          name: 'product',
          params: {
            productName: category.link,
            productId: category.offerProduct
          }
        })
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-item {
  transition: margin 200ms ease-in-out;
  .tile-name {
    font-size: 20px !important;
    font-weight: 600;
  }
}
</style>
